/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";
import "./ServicesSection.css";

// IMPORT IMAGES

// import Icon1 from "../Image/ServiceList/houseekeepingAI.png";
import Icon1 from "../Image/serviceset/iStockHousekeeping.jpg";

// import Icon2 from "../Image/ServiceList/pantryAI.png";
import Icon2 from "../Image/serviceset/ServingTea.jpg";


// import Icon3 from "../Image/ServiceList/EngineeringAI.png";
import Icon3 from "../Image/serviceset/HardServices.jpg";


// import Icon4 from "../Image/ServiceList/faceeeee.png";
import Icon4 from "../Image/ServiceList/service4.jpg";


// import Icon5 from "../Image/ServiceList/DeepCleaning.png";
import Icon5 from "../Image/serviceset/CleaningMachine.jpg";

// import Icon6 from "../Image/ServiceList/industriallll.png";
import Icon6 from "../Image/serviceset/iStockWarehouse.jpg";


const services = [
  {
    icon: Icon1,
    title: "Comprehensive Housekeeping & Janitorial Services",
    desc: "Professional cleaning and maintenance for spotless facilities",
    link: "/housekeeping",
  },
    {
    icon: Icon6,
    title: " Industrial Cleaning & Warehouse deep cleaning",
    desc: "Heavy-duty cleaning for industrial environments",
    link: "/corporate-IndustrialWarehouseCleaning",
  },
  {
    icon: Icon2,
    title: "Pantry & Cafeteria Support Services",
    desc: "Complete pantry management and food service solutions",
    link: "/corporate-pantryservices",
  },
  {
    icon: Icon3,
    title: "Comprehensive Engineering & Technical Maintenance Service",
    desc: "Expert technical support and equipment maintenance",
    link: "/corporate-EngineeringTechnical",
  },
  {
    icon: Icon4,
    title: "Facade & High-Rise Exterior Cleaning",
    desc: "Specialized exterior cleaning for high-rise buildings",
    link: "/corporate-FacadeExternalCleaning",
  },
  {
    icon: Icon5,
    title: "Deep Cleaning & Transformation Services",
    desc: "Intensive cleaning for comprehensive transformation",
    link: "/corporate-deepcleaning",
  },

];

export default function ServicesSection() {
  return (
    <section className="services-section">
      {/* HEADER */}
      <div className="services-header">
        <div className="services-tag">What We Offer</div>
        <h2>Our Core Services</h2>
        <p>
          Comprehensive facility management solutions tailored to your needs
        </p>
      </div>

      {/* GRID */}
      <div className="services-grid">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <div className="service-image">
              <img src={service.icon} alt={service.title} />
            </div>

            <h3>{service.title}</h3>
            <p>{service.desc}</p>

            <Link to={service.link} className="service-link">
              Learn More →
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
